import { graphql } from '@/gql';
import type { CreatePartnerUserMutation, CreatePartnerUserMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type CreatePartnerUserInput = CreatePartnerUserMutationVariables['data'];
export type PartnerUser = CreatePartnerUserMutation['createPartnerUser'];

export const createPartnerUser = async (codeName: string, data: CreatePartnerUserInput): Promise<PartnerUser> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreatePartnerUser($codeName: String!, $data: PartnerUserInputType!) {
        createPartnerUser(codeName: $codeName, data: $data) {
          id
          firstName
          lastName
          email
          highestRole
          isActive
        }
      }
    `),
    variables: {
      codeName,
      data,
    },
  });

  return response.data!.createPartnerUser;
};
